import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=5cc7a01e&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoading.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=5cc7a01e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7a01e",
  null
  
)

export default component.exports